import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { selectIsUseTestAttribute } from '@core/store/selectors/api-config.selectors';

@Directive({
  selector: '[xTentionDummyCypress]',
  standalone: false,
})
export class CypressDirective implements OnChanges, OnDestroy {
  @Input() public xTentionDummyCypress: string;

  @Output() onCloseEdit = new EventEmitter();
  private isAttributeShown$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  private destroySubject$: Subject<void> = new Subject<void>();

  constructor(
    private elRef: ElementRef,
    private store: Store,
  ) {
    this.store
      .pipe(selectIsUseTestAttribute)
      .pipe(
        takeUntil(this.destroySubject$),
        filter((x) => Boolean(x)),
      )
      .subscribe(this.isAttributeShown$);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && this.isAttributeShown$.getValue()) {
      const value = changes?.xTentionDummyCypress?.currentValue;
      (this.elRef.nativeElement as HTMLElement).setAttribute('data-cy', value);
    }
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
